"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
// https://github.com/ethereum-lists/chains/tree/master/_data/chains
exports.networks = [
  { chainId: 1n, shortName: "eth" },
  { chainId: 3n, shortName: "rop" },
  { chainId: 4n, shortName: "rin" },
  { chainId: 5n, shortName: "gor" },
  { chainId: 10n, shortName: "oeth" },
  { chainId: 11n, shortName: "meta" },
  { chainId: 12n, shortName: "kal" },
  { chainId: 14n, shortName: "flr" },
  { chainId: 16n, shortName: "cflr" },
  { chainId: 18n, shortName: "tst" },
  { chainId: 19n, shortName: "sgb" },
  { chainId: 25n, shortName: "cro" },
  { chainId: 28n, shortName: "bobarinkeby" },
  { chainId: 30n, shortName: "rsk" },
  { chainId: 31n, shortName: "trsk" },
  { chainId: 39n, shortName: "u2u" },
  { chainId: 40n, shortName: "telosevm" },
  { chainId: 41n, shortName: "telosevmtestnet" },
  { chainId: 42n, shortName: "kov" },
  { chainId: 43n, shortName: "pangolin" },
  { chainId: 44n, shortName: "crab" },
  { chainId: 46n, shortName: "darwinia" },
  { chainId: 50n, shortName: "xdc" },
  { chainId: 2187n, shortName: "g7" },
  { chainId: 51n, shortName: "txdc" },
  { chainId: 56n, shortName: "bnb" },
  { chainId: 57n, shortName: "sys" },
  { chainId: 61n, shortName: "etc" },
  { chainId: 63n, shortName: "metc" },
  { chainId: 69n, shortName: "okov" },
  { chainId: 71n, shortName: "cfxtest" },
  { chainId: 81n, shortName: "joc" },
  { chainId: 82n, shortName: "meter" },
  { chainId: 83n, shortName: "meter-test" },
  { chainId: 88n, shortName: "tomo" },
  { chainId: 96n, shortName: "bkc" },
  { chainId: 97n, shortName: "bnbt" },
  { chainId: 100n, shortName: "gno" },
  { chainId: 106n, shortName: "vlx" },
  { chainId: 108n, shortName: "tt" },
  { chainId: 109n, shortName: "shibariumecosystem" },
  { chainId: 111n, shortName: "etl" },
  { chainId: 114n, shortName: "c2flr" },
  { chainId: 122n, shortName: "fuse" },
  { chainId: 123n, shortName: "spark" },
  { chainId: 130n, shortName: "unichain" },
  { chainId: 133n, shortName: "HSKT" },
  { chainId: 137n, shortName: "matic" },
  { chainId: 146n, shortName: "sonic" },
  { chainId: 148n, shortName: "shimmerevm" },
  { chainId: 155n, shortName: "tenet-testnet" },
  { chainId: 169n, shortName: "manta" },
  { chainId: 177n, shortName: "hsk" },
  { chainId: 179n, shortName: "abey" },
  { chainId: 181n, shortName: "water" },
  { chainId: 195n, shortName: "tokb" },
  { chainId: 196n, shortName: "okb" },
  { chainId: 204n, shortName: "opbnb" },
  { chainId: 240n, shortName: "zkTCRO" },
  { chainId: 246n, shortName: "ewt" },
  { chainId: 250n, shortName: "ftm" },
  { chainId: 252n, shortName: "fraxtal" },
  { chainId: 255n, shortName: "kroma" },
  { chainId: 274n, shortName: "lachain" },
  { chainId: 280n, shortName: "zksync-goerli" },
  { chainId: 282n, shortName: "zkTCRO" },
  { chainId: 288n, shortName: "boba" },
  { chainId: 291n, shortName: "orderly" },
  { chainId: 300n, shortName: "zksync-sepolia" },
  { chainId: 314n, shortName: "filecoin" },
  { chainId: 321n, shortName: "kcs" },
  { chainId: 322n, shortName: "kcst" },
  { chainId: 324n, shortName: "zksync" },
  { chainId: 336n, shortName: "sdn" },
  { chainId: 338n, shortName: "tcro" },
  { chainId: 360n, shortName: "shape" },
  { chainId: 369n, shortName: "pls" },
  { chainId: 388n, shortName: "zkCRO" },
  { chainId: 418n, shortName: "latestnet" },
  { chainId: 420n, shortName: "ogor" },
  { chainId: 424n, shortName: "PGN" },
  { chainId: 466n, shortName: "appchain" },
  { chainId: 478n, shortName: "formnetwork" },
  { chainId: 480n, shortName: "wc" },
  { chainId: 530n, shortName: "FxCore" },
  { chainId: 570n, shortName: "sys-rollux" },
  { chainId: 588n, shortName: "metis-stardust" },
  { chainId: 592n, shortName: "astr" },
  { chainId: 595n, shortName: "maca" },
  { chainId: 599n, shortName: "metis-goerli" },
  { chainId: 648n, shortName: "ace" },
  { chainId: 686n, shortName: "kar" },
  { chainId: 690n, shortName: "redstone" },
  { chainId: 787n, shortName: "aca" },
  { chainId: 919n, shortName: "modesep" },
  { chainId: 938n, shortName: "haust" },
  { chainId: 943n, shortName: "t4pls" },
  { chainId: 970n, shortName: "ccn" },
  { chainId: 995n, shortName: "5ire" },
  { chainId: 1001n, shortName: "baobab" },
  { chainId: 1008n, shortName: "eun" },
  { chainId: 1030n, shortName: "cfx" },
  { chainId: 1088n, shortName: "metis-andromeda" },
  { chainId: 1101n, shortName: "zkevm" },
  { chainId: 1111n, shortName: "wemix" },
  { chainId: 1112n, shortName: "twemix" },
  { chainId: 1114n, shortName: "tcore2" },
  { chainId: 1115n, shortName: "tcore" },
  { chainId: 1116n, shortName: "core" },
  { chainId: 1125n, shortName: "taker" },
  { chainId: 1135n, shortName: "lisk" },
  { chainId: 1230n, shortName: "UltronTestnet" },
  { chainId: 1231n, shortName: "UltronMainnet" },
  { chainId: 1284n, shortName: "mbeam" },
  { chainId: 1285n, shortName: "mriver" },
  { chainId: 1287n, shortName: "mbase" },
  { chainId: 1294n, shortName: "bobabeam" },
  { chainId: 1329n, shortName: "sei" },
  { chainId: 1337n, shortName: "geth" },
  { chainId: 1442n, shortName: "testnet-zkEVM-mango" },
  { chainId: 1513n, shortName: "Story" },
  { chainId: 1516n, shortName: "story-testnet" },
  { chainId: 1559n, shortName: "tenet" },
  { chainId: 1625n, shortName: "gravity" },
  { chainId: 1663n, shortName: "Gobi" },
  { chainId: 1729n, shortName: "reya" },
  { chainId: 1750n, shortName: "metall2" },
  { chainId: 1807n, shortName: "rana" },
  { chainId: 1811n, shortName: "lif3-testnet" },
  { chainId: 1890n, shortName: "lightlink_phoenix" },
  { chainId: 1891n, shortName: "lightlink_pegasus" },
  { chainId: 1923n, shortName: "swellchain" },
  { chainId: 1924n, shortName: "swellchain-sep" },
  { chainId: 1984n, shortName: "euntest" },
  { chainId: 1998n, shortName: "kyoto-testnet" },
  { chainId: 2000n, shortName: "dc" },
  { chainId: 2001n, shortName: "milkada" },
  { chainId: 2002n, shortName: "milkalgo" },
  { chainId: 2008n, shortName: "cloudwalk_testnet" },
  { chainId: 2019n, shortName: "pmint_test" },
  { chainId: 2020n, shortName: "pmint" },
  { chainId: 2021n, shortName: "edg" },
  { chainId: 2039n, shortName: "aleph" },
  { chainId: 2187n, shortName: "g7" },
  { chainId: 13746n, shortName: "g7t" },
  { chainId: 2192n, shortName: "snax" },
  { chainId: 2221n, shortName: "tkava" },
  { chainId: 2222n, shortName: "kava" },
  { chainId: 2331n, shortName: "rss3-testnet" },
  { chainId: 2358n, shortName: "kroma-sepolia" },
  { chainId: 2442n, shortName: "zkevm-testnet-cardona" },
  { chainId: 2810n, shortName: "hmorph" },
  { chainId: 2818n, shortName: "morph" },
  { chainId: 3338n, shortName: "PEAQ" },
  { chainId: 3501n, shortName: "JFIN" },
  { chainId: 3636n, shortName: "BTNX" },
  { chainId: 3737n, shortName: "csb" },
  { chainId: 3776n, shortName: "astrzk" },
  { chainId: 4002n, shortName: "tftm" },
  { chainId: 4061n, shortName: "Nahmii3Mainnet" },
  { chainId: 4062n, shortName: "Nahmii3Testnet" },
  { chainId: 4078n, shortName: "muster" },
  { chainId: 4157n, shortName: "crossfi-testnet" },
  { chainId: 4162n, shortName: "SXR" },
  { chainId: 4202n, shortName: "lisksep" },
  { chainId: 4337n, shortName: "beam" },
  { chainId: 4460n, shortName: "orderlyl2" },
  { chainId: 4653n, shortName: "gold" },
  { chainId: 4661n, shortName: "appchaintestnet" },
  { chainId: 4689n, shortName: "iotex-mainnet" },
  { chainId: 4918n, shortName: "txvm" },
  { chainId: 4919n, shortName: "xvm" },
  { chainId: 5000n, shortName: "mantle" },
  { chainId: 5001n, shortName: "mantle-testnet" },
  { chainId: 5003n, shortName: "mnt-sep" },
  { chainId: 5115n, shortName: "citrea-testnet" },
  { chainId: 5165n, shortName: "ftn" },
  { chainId: 5611n, shortName: "obnbt" },
  { chainId: 5700n, shortName: "tsys" },
  { chainId: 6001n, shortName: "bouncebit-mainnet" },
  { chainId: 6102n, shortName: "cascadia" },
  { chainId: 6321n, shortName: "eaura" },
  { chainId: 6322n, shortName: "aura" },
  { chainId: 6398n, shortName: "connext-sepolia" },
  { chainId: 6688n, shortName: "iris" },
  { chainId: 7000n, shortName: "zetachain-mainnet" },
  { chainId: 7001n, shortName: "zetachain-testnet" },
  { chainId: 7171n, shortName: "bitrock" },
  { chainId: 7200n, shortName: "xsat" },
  { chainId: 7332n, shortName: "EON" },
  { chainId: 7341n, shortName: "shyft" },
  { chainId: 7560n, shortName: "cyeth" },
  { chainId: 7700n, shortName: "canto" },
  { chainId: 7771n, shortName: "tbitrock" },
  { chainId: 8192n, shortName: "tqf" },
  { chainId: 8194n, shortName: "ttqf" },
  { chainId: 8217n, shortName: "cypress" },
  { chainId: 8329n, shortName: "lrz" },
  { chainId: 8453n, shortName: "base" },
  { chainId: 8822n, shortName: "iotaevm" },
  { chainId: 9000n, shortName: "evmos-testnet" },
  { chainId: 9001n, shortName: "evmos" },
  { chainId: 9700n, shortName: "MainnetDev" },
  { chainId: 9728n, shortName: "boba-testnet" },
  { chainId: 10000n, shortName: "smartbch" },
  { chainId: 10001n, shortName: "smartbchtest" },
  { chainId: 10081n, shortName: "joct" },
  { chainId: 10200n, shortName: "chi" },
  { chainId: 10242n, shortName: "aa" },
  { chainId: 10243n, shortName: "aat" },
  { chainId: 10849n, shortName: "lamina1" },
  { chainId: 11011n, shortName: "shapesep" },
  { chainId: 11111n, shortName: "WAGMI" },
  { chainId: 11235n, shortName: "islm" },
  { chainId: 11437n, shortName: "shyftt" },
  { chainId: 11501n, shortName: "bevm" },
  { chainId: 11503n, shortName: "bevm-test" },
  { chainId: 11820n, shortName: "artela-mainnet" },
  { chainId: 11891n, shortName: "Arianee" },
  { chainId: 12324n, shortName: "l3x" },
  { chainId: 12325n, shortName: "l3x-testnet" },
  { chainId: 12357n, shortName: "rei-testnet" },
  { chainId: 12553n, shortName: "rss3" },
  { chainId: 13337n, shortName: "beam-testnet" },
  { chainId: 13371n, shortName: "imx" },
  { chainId: 13473n, shortName: "imx-testnet" },
  { chainId: 13746n, shortName: "g7t" },
  { chainId: 14800n, shortName: "vana-moksha" },
  { chainId: 17000n, shortName: "holesky" },
  { chainId: 17069n, shortName: "garnet" },
  { chainId: 17172n, shortName: "eclipse" },
  { chainId: 18231n, shortName: "unreal-old" },
  { chainId: 18233n, shortName: "unreal" },
  { chainId: 22776n, shortName: "mapo" },
  { chainId: 23294n, shortName: "sapphire" },
  { chainId: 23295n, shortName: "sapphire-testnet" },
  { chainId: 25327n, shortName: "Everclear" },
  { chainId: 28979n, shortName: "kimbonet-testnet" },
  { chainId: 31611n, shortName: "mezo" },
  { chainId: 32769n, shortName: "zil" },
  { chainId: 33101n, shortName: "zil-testnet" },
  { chainId: 33139n, shortName: "apechain" },
  { chainId: 33401n, shortName: "slingshot" },
  { chainId: 34443n, shortName: "mode" },
  { chainId: 35441n, shortName: "q" },
  { chainId: 35443n, shortName: "q-testnet" },
  { chainId: 37111n, shortName: "lens-sepolia" },
  { chainId: 41455n, shortName: "aleph-zero" },
  { chainId: 42161n, shortName: "arb1" },
  { chainId: 42170n, shortName: "arb-nova" },
  { chainId: 42220n, shortName: "celo" },
  { chainId: 42421n, shortName: "rwa" },
  { chainId: 42793n, shortName: "etlk" },
  { chainId: 43111n, shortName: "hemi" },
  { chainId: 43113n, shortName: "fuji" },
  { chainId: 43114n, shortName: "avax" },
  { chainId: 43288n, shortName: "boba-avax" },
  { chainId: 44787n, shortName: "alfa" },
  { chainId: 45000n, shortName: "autobahnnetwork" },
  { chainId: 47763n, shortName: "neox-mainnet" },
  { chainId: 47805n, shortName: "rei" },
  { chainId: 48899n, shortName: "zircuit-testnet" },
  { chainId: 48900n, shortName: "zircuit-mainnet" },
  { chainId: 53457n, shortName: "dodochain" },
  { chainId: 54211n, shortName: "islmt" },
  { chainId: 56288n, shortName: "boba-bnb" },
  { chainId: 57000n, shortName: "tsys-rollux" },
  { chainId: 57054n, shortName: "blaze" },
  { chainId: 57073n, shortName: "ink" },
  { chainId: 58008n, shortName: "sepPGN" },
  { chainId: 59140n, shortName: "linea-goerli" },
  { chainId: 59141n, shortName: "linea-sepolia" },
  { chainId: 59144n, shortName: "linea" },
  { chainId: 60808n, shortName: "bob" },
  { chainId: 61166n, shortName: "treasure" },
  { chainId: 71401n, shortName: "gw-testnet-v1" },
  { chainId: 71402n, shortName: "gw-mainnet-v1" },
  { chainId: 73799n, shortName: "vt" },
  { chainId: 80001n, shortName: "maticmum" },
  { chainId: 80002n, shortName: "polygonamoy" },
  { chainId: 80084n, shortName: "berachainbArtio" },
  { chainId: 80085n, shortName: "berachainArtio" },
  { chainId: 80094n, shortName: "berachain" },
  { chainId: 81457n, shortName: "blastmainnet" },
  { chainId: 83291n, shortName: "lrz-testnet" },
  { chainId: 84531n, shortName: "basegor" },
  { chainId: 84532n, shortName: "basesep" },
  { chainId: 90001n, shortName: "dhobyghaut" },
  { chainId: 97435n, shortName: "sling" },
  { chainId: 98864n, shortName: "plume-devnet" },
  { chainId: 98865n, shortName: "plume" },
  { chainId: 103454n, shortName: "masatest" },
  { chainId: 105105n, shortName: "stratis" },
  { chainId: 111188n, shortName: "re-al" },
  { chainId: 128123n, shortName: "etlt" },
  { chainId: 167000n, shortName: "tko-mainnet" },
  { chainId: 167008n, shortName: "tko-katla" },
  { chainId: 167009n, shortName: "tko-hekla" },
  { chainId: 175188n, shortName: "lpy" },
  { chainId: 200101n, shortName: "milktada" },
  { chainId: 200202n, shortName: "milktalgo" },
  { chainId: 200810n, shortName: "btrt" },
  { chainId: 205205n, shortName: "auroria" },
  { chainId: 314159n, shortName: "filecoin-calibration" },
  { chainId: 328527n, shortName: "nal" },
  { chainId: 333999n, shortName: "olympus" },
  { chainId: 381931n, shortName: "metal" },
  { chainId: 421611n, shortName: "arb-rinkeby" },
  { chainId: 421613n, shortName: "arb-goerli" },
  { chainId: 421614n, shortName: "arb-sep" },
  { chainId: 444444n, shortName: "syndr" },
  { chainId: 490000n, shortName: "ATN" },
  { chainId: 534351n, shortName: "scr-sepolia" },
  { chainId: 534352n, shortName: "scr" },
  { chainId: 534353n, shortName: "scr-alpha" },
  { chainId: 543210n, shortName: "zero-network" },
  { chainId: 555666n, shortName: "eclipset" },
  { chainId: 622277n, shortName: "rth" },
  { chainId: 656476n, shortName: "open-campus-codex" },
  { chainId: 660279n, shortName: "xai" },
  { chainId: 668668n, shortName: "cnw" },
  { chainId: 713715n, shortName: "sei-devnet" },
  { chainId: 743111n, shortName: "hemi-sep" },
  { chainId: 763373n, shortName: "inksepolia" },
  { chainId: 764984n, shortName: "lamina1test" },
  { chainId: 808813n, shortName: "bob-sepolia" },
  { chainId: 810180n, shortName: "zklink-nova" },
  { chainId: 839999n, shortName: "txsat" },
  { chainId: 978657n, shortName: "treasure-ruby" },
  { chainId: 984122n, shortName: "forma" },
  { chainId: 1501869n, shortName: "water9" },
  { chainId: 3441006n, shortName: "mantaSepoliaTestnet" },
  { chainId: 4457845n, shortName: "zero-sepolia" },
  { chainId: 6038361n, shortName: "azkyt" },
  { chainId: 7225878n, shortName: "saakuru" },
  { chainId: 7777777n, shortName: "zora" },
  { chainId: 9999999n, shortName: "fluence" },
  { chainId: 11155111n, shortName: "sep" },
  { chainId: 11155420n, shortName: "opsep" },
  { chainId: 12227332n, shortName: "neox-t4" },
  { chainId: 52164803n, shortName: "fluence-testnet" },
  { chainId: 94204209n, shortName: "polygon-blackberry" },
  { chainId: 111557560n, shortName: "cysep" },
  { chainId: 123420111n, shortName: "opcelestia-raspberry" },
  { chainId: 161221135n, shortName: "plume-testnet" },
  { chainId: 168587773n, shortName: "blastsepolia" },
  { chainId: 222000222n, shortName: "kanazawa" },
  { chainId: 245022926n, shortName: "neonevm-devnet" },
  { chainId: 245022934n, shortName: "neonevm-mainnet" },
  { chainId: 253368190n, shortName: "flame" },
  { chainId: 328527624n, shortName: "nalsep" },
  { chainId: 333000333n, shortName: "meld" },
  { chainId: 476462898n, shortName: "Skopje" },
  { chainId: 666666666n, shortName: "degen-chain" },
  { chainId: 888888888n, shortName: "ancient8" },
  { chainId: 999999999n, shortName: "zsep" },
  { chainId: 1313161554n, shortName: "aurora" },
  { chainId: 1313161555n, shortName: "aurora-testnet" },
  { chainId: 1511670449n, shortName: "GPT" },
  { chainId: 1570754601n, shortName: "hst-test" },
  { chainId: 1666600000n, shortName: "hmy-s0" },
  { chainId: 1666700000n, shortName: "hmy-b-s0" },
  { chainId: 11297108099n, shortName: "tpalm" },
  { chainId: 11297108109n, shortName: "palm" },
  { chainId: 37714555429n, shortName: "xaitestnet" },
  { chainId: 88153591557n, shortName: "arb-blueberry" },
  { chainId: 123420000220n, shortName: "fluence-stage" },
  { chainId: 920637907288165n, shortName: "kkrt-starknet-sepolia" },
];
if (process.env.TEST_NETWORK === "hardhat") {
  exports.networks.push({ shortName: "local", chainId: 31337n });
}
//# sourceMappingURL=config.js.map